import { createSignal, onMount, Show } from "solid-js";
import IconLockBold from "./assets/icons/lock-bold.svg";
import { global } from ":shared/app";

export default function (props: { locked: boolean }) {
  const $breakpoint = global.store.hooks.dom.useBreakpoints();
  let ref: HTMLDivElement = undefined;
  let tooltip: HTMLDivElement = undefined;
  function mousemove(e: MouseEvent) {
    tooltip.style.left = e.pageX + "px";
    tooltip.style.top = e.pageY * 0.09 + "px";
    // console.log("wow :: ", e.pageY * 0.5);
    // for (var i=tooltip.length; i--;) {
    //     tooltip[i].style.left = e.pageX + 'px';
    //     tooltip[i].style.top = e.pageY + 'px';
    // }
  }
  function mouseenter() {
    tooltip.style.display = "flex";
  }

  function mouseleave() {
    tooltip.style.display = "none";
  }

  onMount(() => {
    if (ref != undefined) {
      // tooltip = ref.getElementsByClassName(".tooltip-move")[0];
      // console.log("tooltip", ref.getElementsByTagName(".tooltip-move"));
      ref.addEventListener("mousemove", mousemove, false);
      ref.addEventListener("mouseenter", mouseenter, false);
      ref.addEventListener("mouseleave", mouseleave, false);
    }
  });

  function onClick() {
    if ($breakpoint()?.misc?.sm?.widthIsGreaterOrEquals) {
      return;
    }
    global.store.actions.toast.pushToast({
      type: "error",
      message: "this page is locked by admin!",
    });
  }

  return (
    <Show when={props.locked}>
      <div
        onclick={onClick}
        ref={ref}
        class={`-ml2
          absolute top-0 flex flex-row w-full h-full
          group items-center justify-end rounded-md 
          px-1
          cursor-not-allowed
        `}
      >
        <div
          ref={tooltip}
          id="tooltip-move"
          class="absolute top-0 capitalize w-fit h-fit ml-1 hidden bg-bg-alt px-1 py-1 z-100 rounded-md text-14px"
        >
          locked by admin
        </div>
        <IconLockBold class="w-24px  text-text" />
      </div>
    </Show>
  );
}
